import { render, staticRenderFns } from "./AulasAlunoModal.vue?vue&type=template&id=360ac828&scoped=true"
import script from "./AulasAlunoModal.vue?vue&type=script&lang=js"
export * from "./AulasAlunoModal.vue?vue&type=script&lang=js"
import style0 from "./AulasAlunoModal.vue?vue&type=style&index=0&id=360ac828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360ac828",
  null
  
)

export default component.exports